import { processLayoutOptions, SecondaryBlockType } from "@kameleon-core/lib";
import { InferProps } from "prop-types";

export const layoutOptions = {};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type QuotesType = {
  icon: string;
  quote?: string;
  name?: string;
  primaryButtonText: string;
  primaryButtonLink?: string;
  secondaryButtonText: string;
  secondaryButtonLink?: string;
} & SecondaryBlockType<LayoutProps>;
